import { render, staticRenderFns } from "./AppointmentApprovePreview.vue?vue&type=template&id=36568317&"
import script from "./AppointmentApprovePreview.vue?vue&type=script&lang=js&"
export * from "./AppointmentApprovePreview.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentApprovePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports